import {RootState} from "../../store";

export const forcePasswordChangeSelector = (state: RootState) => {
    return state.credentials.records.forcePasswordChange;
};

export const credentialsErrorSelector = (state: RootState) => {
    return state.credentials.records.error;
};

export const cognitoUserSelector = (state: RootState) => {
    return state.credentials.records.cognitoUser;
};
